import { firstValueFrom } from 'rxjs';
import { HttpService } from '../../../services/http-service/http.service';
import { Component, inject, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DoctorService } from '../../../services/doctor-service/doctor.service';
import { Router } from '@angular/router';

interface WishlistInterest {
    id: number;
    nome: string;
    produto_sinalizado: string;
    sinalizado_em: string;
    removido_em: string | null;
}

@Component({
    selector: 'app-edit-doctor',
    standalone: false,
    templateUrl: './edit-doctor.html',
    styleUrl: './edit-doctor.scss',
})
export class EditDoctor {
    doctor: any;
    private readonly http = inject(HttpService);
    wishlist: WishlistInterest[] = [];
    wishlistError = false;
    wishlistLoading = true;

    get activeWishlist() {
        return this.wishlist.filter(interest => !interest.removido_em);
    }

    get wishlistActions() {
        return this.wishlist.flatMap(interest => {
            const actions = [{ id: interest.id + '-inclusao', produto: interest.produto_sinalizado,
                acao: 'Inclusão', em: interest.sinalizado_em }];
            if (interest.removido_em) actions.push({ id: interest.id + '-remocao',
                produto: interest.produto_sinalizado, acao: 'Remoção', em: interest.removido_em });
            return actions;
        }).sort((a, b) => b.em.localeCompare(a.em));
    }
    loading: boolean = false;
    readOnly: boolean = false;
    editableFields: string[] = [];
    readonly dialogRef = inject(MatDialogRef<EditDoctor>);

    constructor(@Inject(MAT_DIALOG_DATA) public data: {
        doctor: any,
        readOnly?: boolean,
        editableFields?: string[],
    },
        @Inject(DoctorService) private doctorService: DoctorService,
        private router: Router
    ) {
        this.doctor = { ...data.doctor };
        this.readOnly = data.readOnly || false;
        this.editableFields = data.editableFields || [];
    }

    async ngOnInit(): Promise<void> {
        await this.getDoctorDetails(this.doctor);
        await this.loadWishlist();
    }

  async getDoctorDetails(params: any): Promise<void> {
    this.loading = true;
    this.doctor = await this.doctorService.getDoctorDetails(params);
    // console.log('doctor: ' + JSON.stringify(this.doctor));
    this.loading = false;
  }

    async loadWishlist(): Promise<void> {
        this.wishlistLoading = true;
        this.wishlistError = false;
        try {
            const response = await firstValueFrom(this.http.get('v1/adm/chiesi/lista-desejos/medico',
                { cpf: this.doctor.cpf }, this.http.setHeaderConfig(true)));
            if (response.status !== 200) throw new Error(response.message);
            this.wishlist = response.result;
        } catch {
            this.wishlistError = true;
        } finally {
            this.wishlistLoading = false;
        }
    }

    async save() {
        this.loading = true;
        await this.doctorService.updateDoctor(this.doctor);
        this.loading = false;
        this.dialogRef.close(this.doctor);
    }

    // Verificar se campo é editável
    isFieldEditable(fieldName: string): boolean {
        return !this.readOnly || this.editableFields.includes(fieldName);
    }

    // Fechar diálogo sem salvar
    cancel(): void {
        this.dialogRef.close();
    }

    getStatusClass(status: string): string {
        if (!status) return 'status-default';

        const statusLower = status?.toLowerCase().trim();

        switch (statusLower) {
            case 'pendente':
                return 'status-pendente';
            case 'aprovado':
                return 'status-aprovado';
            case 'em processamento':
                return 'status-processamento';
            case 'enviado':
                return 'status-enviado';
            case 'entregue':
                return 'status-entregue';
            case 'cancelado':
                return 'status-cancelado';
            case 'cancelado pelo programa':
                return 'status-cancelado-programa';
            case 'devolvido':
                return 'status-devolvido';
            default:
                return 'status-default';
        }
    }

  goToOrder(data: string, numeroPedido: string) {
    // console.log('Ir para o pedido');
    // console.log('data: ' + data);
    // console.log('numero: ' + numeroPedido);
    this.dialogRef.close();
    this.router.navigate(['/home/rescues'], {queryParams: {data: data, pedido: numeroPedido}});
  }

  formatDate(date: any) {
    if (!date) return '';
    try {
      const formatted = new Date(date).toLocaleString();
      return formatted;
    } catch (error) {
      console.error('Erro ao formatar data:', error);
      return '';
    }

  }

}
